import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { gstList } from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";

const GstList = () => {
  const [GstList, setGstList] = useState([]);
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);

  useEffect(() => {
    const fetchGstList = async () => {
      try {
        const response = await gstList(token);
        setGstList(response.data)
        console.log("list : ",response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchGstList();
  }, []);

  return (
    <div id="main_content">
      <Header />
      <div className="page">
       <Section/>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">GstList</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    GstList
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Gst List-all">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Roll No."
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Department"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <div className="input-group">
                          <input
                            data-provide="datepicker"
                            data-date-autoclose="true"
                            className="form-control"
                            placeholder="Admission Date"
                          />
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4 col-sm-6">
                        <a
                          href="javascript:void(0);"
                          className="btn btn-sm btn-primary btn-block"
                          title
                        >
                          Search
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive card">
                  <table className="table table-hover table-vcenter table-striped mb-0 text-nowrap">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Gst Percent</th>
                        <th>State</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {GstList.map((GstList) => (
                         <tr key={GstList.id}>
                         <td>{GstList.id}</td>
                         <td>
                           {GstList.gstPercent}
                         </td>
                         <td>
                            <button
                              className={`btn btn-sm ${
                                GstList?.status ? "btn-primary" : "btn-danger"
                              }`}
                            //   onClick={() => toggleStatus(category?.id)}
                            >
                              {GstList?.status ? "Active" : "Inactive"}
                            </button>
                          </td>
                         <td>
                         <button
                           type="button"
                           className="btn btn-icon btn-sm"
                           title="View"
                         >
                           <i className="fa fa-eye" />
                         </button>
                         <button
                           type="button"
                           className="btn btn-icon btn-sm"
                           title="Edit"
                         >
                           <i className="fa fa-edit" />
                         </button>
                         <button
                           type="button"
                           className="btn btn-icon btn-sm js-sweetalert"
                           title="Delete"
                           data-type="confirm"
                         >
                           <i className="fa fa-trash-o text-danger" />
                         </button>
                       </td>
                       </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default GstList;
